import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useResource } from "@rest-hooks/core";
import { DriverResource } from "@ploy-lib/rest-resources";
import { useVariableData } from "@ploy-lib/calculation";
import { DployAutocomplete, useFieldToTextField, DployFormControl } from "@ploy-ui/form-fields";
import { Grid, Dialog, FormLabel, makeStyles, Card, CardHeader, IconButton, CardContent } from "@material-ui/core";
import { Edit, Close } from "@material-ui/icons";
import { PendingButton } from "@ploy-ui/core";
import { FormattedMessage } from "react-intl";
import { DriverForm } from "./DriverForm";
export const DriverSelect = (props) => {
    const { form, field, label, className, multiple, ...rest } = props;
    const { autoComplete, ...textFieldProps } = useFieldToTextField(props);
    const { name } = field;
    const { setFieldValue } = form;
    const { value: customerId } = useVariableData("Customer", "CustomerId");
    const [currentCustomer, setCurrentCustomer] = useState(customerId);
    const drivers = useResource(DriverResource.list(), customerId &&
        !Number.isNaN(Number(customerId)) &&
        Number(customerId) !== 0
        ? { customerId }
        : null) || [];
    const { value: selectedDriverNumber } = useVariableData("Main", "Driver");
    const selectedDriver = drivers.find(x => x.driverId === selectedDriverNumber);
    const [selected, setSelected] = useState(selectedDriver);
    useEffect(() => {
        //reset selectedDriver on customerId change
        if (currentCustomer !== customerId) {
            setCurrentCustomer(customerId);
            setFieldValue(name, 0);
            setSelected(undefined);
        }
    }, [currentCustomer, customerId, name, setFieldValue]);
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const classes = useStyles(props);
    const message = (_jsx(FormattedMessage, { id: "form.driver.editDriver", description: "Card header title for drivers editor", defaultMessage: "Edit drivers" }));
    const [requestClose, setRequestClose] = useState(false);
    const closeRequest = {
        closeCallback: () => {
            setDialogIsOpen(false);
            setRequestClose(false);
        },
        cancelCallback: () => setRequestClose(false)
    };
    return (_jsxs(_Fragment, { children: [_jsx(Dialog, { open: dialogIsOpen, PaperProps: { style: { width: "100%" } }, children: _jsxs(Card, { children: [_jsx(CardHeader, { className: classes.mainThemeBackground, action: _jsx(IconButton, { color: "inherit", onClick: () => {
                                    setRequestClose(true);
                                }, children: _jsx(Close, {}) }), title: message }), _jsx(CardContent, { className: classes.cardContent, children: _jsx(DriverForm, { requestClose: requestClose ? closeRequest : undefined, customerId: customerId, selected: selected, onDriverSaved: driver => {
                                    setSelected(driver);
                                    setFieldValue(name, driver.driverId);
                                    setDialogIsOpen(false);
                                } }) })] }) }), _jsxs(Grid, { container: true, wrap: "nowrap", children: [_jsx(Grid, { item: true, xs: 9, children: _jsx(DployAutocomplete, { ...rest, ...textFieldProps, items: drivers, getItemLabel: driver => driver.firstname + " " + driver.lastname, value: selected ?? null, onChange: (e, val) => {
                                setSelected(val ?? undefined);
                                val ? setFieldValue(name, val.driverId) : setFieldValue(name, 0);
                            }, disableClearable: !rest.clearable, defaultValue: undefined }) }), _jsx(Grid, { item: true, xs: 3, children: _jsxs(DployFormControl, { className: classes.editButtonContainer, margin: "normal", children: [label && _jsx(FormLabel, { children: " " }), _jsx(PendingButton, { pending: false, variant: "outlined", size: "large", onClick: () => {
                                        setDialogIsOpen(true);
                                    }, disabled: Number(customerId) === 0, success: false, className: classes.editButton, fullWidth: true, children: _jsx(Edit, {}) })] }) })] })] }));
};
const useStyles = makeStyles(theme => ({
    editButton: {
        padding: 0,
        minWidth: 0
    },
    editButtonContainer: {
        width: "100%"
    },
    cardContent: {
        maxHeight: "80vh",
        overflow: "auto"
    },
    mainThemeBackground: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    }
}));
//# sourceMappingURL=DriverSelect.js.map